import React, { useEffect } from 'react';
import { Pressable, View, Text } from 'react-native';

import Modal from 'react-native-modal';
import AppStyles from '../../AppStyles';
import AppTheme from '../../AppTheme';
import TextStyle from '../../TextStyle';

const TitlePopup = (props) => {
    const showPopup = props.showPopup
    const modalData = props?.modalData
    const hasBackdrop = props?.hasBackdrop ?? true
    const closeModal = props.closeModal
    const primaryAction = props?.primaryAction
    useEffect(() => {
        if (showPopup) {
            var popUpTimer = setTimeout(() => {
                closeModal(); primaryAction()
                clearTimeout(popUpTimer);
            }, 4000);
        }
    }, [showPopup])
    return (<Modal isVisible={showPopup}
        hasBackdrop={hasBackdrop}
        animationOut={"slideOutDown"}
        deviceHeight={AppTheme.modalHeight}
        backdropOpacity={AppTheme.modalBackdropOpacity}
        animationOutTiming={AppTheme.modalAnimationDuration}
        onBackdropPress={() => closeModal()}>
        <View style={AppStyles.modalContainer}>
            <Text style={[TextStyle.text18b]}>
                {modalData['title']}</Text>
            <Text style={[TextStyle.text16, { paddingTop: 4 }]}>
                {modalData['subTitle']}</Text>
            <Pressable style={{ paddingRight: 16, paddingTop: 6 }}
                onPress={() => { closeModal(); primaryAction() }}>
                <Text style={[TextStyle.text18b, {
                    textAlign: "right", color: AppTheme.color.primary
                }]}>{modalData['ctaTitle'] ?? 'OK'}</Text>
            </Pressable>
        </View>
    </Modal>)
}

export default TitlePopup